import { render, staticRenderFns } from "./TelegramIcon.vue?vue&type=template&id=12e89946"
import script from "./TelegramIcon.vue?vue&type=script&lang=js"
export * from "./TelegramIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports